var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_help_circle_grey",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1259",
    "data-name": "Rectangle 1259",
    width: 25,
    height: 25,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M10.708,2h2.083V-.083H10.708V2ZM11.75-14.667A10.42,10.42,0,0,0,1.333-4.25,10.42,10.42,0,0,0,11.75,6.167,10.42,10.42,0,0,0,22.167-4.25,10.42,10.42,0,0,0,11.75-14.667Zm0,18.75A8.344,8.344,0,0,1,3.417-4.25a8.344,8.344,0,0,1,8.333-8.333A8.344,8.344,0,0,1,20.083-4.25,8.344,8.344,0,0,1,11.75,4.083Zm0-14.583A4.166,4.166,0,0,0,7.583-6.333H9.667A2.089,2.089,0,0,1,11.75-8.417a2.089,2.089,0,0,1,2.083,2.083c0,2.083-3.125,1.823-3.125,5.208h2.083c0-2.344,3.125-2.6,3.125-5.208A4.166,4.166,0,0,0,11.75-10.5Z",
    transform: "translate(0.75 16.75)",
    fill: "#666b6e",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/HelpCircle.13ec418d1f2aace6611409a810f14e13.svg";
export { ForwardRef as ReactComponent };